/**
 * Imports
 */
import { createAction } from '@reduxjs/toolkit';
import { VibrantlyAction } from 'store/types';

import { User } from '../types';

/**
 * Constants
 */
const PREFIX = 'user';

/**
 * USER_UPDATED
 */
export const USER_UPDATED = `${PREFIX}/USER_UPDATED`;
export type UserUpdatedAction = VibrantlyAction<User>;
export const userUpdated = createAction<UserUpdatedAction['payload']>(
  USER_UPDATED,
);

/**
 * LOGOUT
 */
export const LOGOUT = `${PREFIX}/LOGOUT`;
export type LogoutAction = VibrantlyAction<{}>;
export const logout = createAction<LogoutAction['payload']>(LOGOUT);
